import { createSlice } from '@reduxjs/toolkit';

interface AgentState {
  agent: {
    templateId: string;
    assistantName: string;
    deleted: boolean;
    agentKey: string;
    status: string;
    file: {
      versionId: string;
      version: number;
      firstMessage: string;
      identity: string;
      context: string;
      job: string;
      examples: string;
      constraints: string;
      format: string;
      tone: string;
      label: string[];
    };
    _id: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
}

const initialState: AgentState = {
  agent: {
    templateId: '',
    assistantName: '',
    deleted: false,
    agentKey: '',
    status: 'draft',
    file: {
      versionId: '',
      version: 1,
      firstMessage: '',
      identity: '',
      context: '',
      job: '',
      examples: '',
      constraints: '',
      format: '',
      tone: '',
      label: [],
    },
    _id: '',
    createdAt: '',
    updatedAt: '',
    __v: 0,
  },
};

const agentSlice = createSlice({
  name: 'agent',
  initialState,
  reducers: {
    setAgent: (state, action) => {
      state.agent = action.payload;
    },
    clearAgent: state => {
      state.agent = initialState.agent;
    },
    updateAgentField: (state, action) => {
      const { field, value } = action.payload;
      if (field in state.agent) {
        (state.agent as any)[field] = value;
      }
    },
  },
});

export const { setAgent, clearAgent, updateAgentField } = agentSlice.actions;
export default agentSlice.reducer;
